import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Heading from '../components/heading/Heading';
import Text from '../components/text/Text';
import Button from '../components/buttons/Button';
import phoneIco from './../images/phone-ico.svg';
import envelopeIco from './../images/envelope-ico.svg'
import TagManager from 'react-gtm-module'
import lawForms from './../static-data/law-forms.json';
import proffessions from './../static-data/professions.json';
import getDataFromUrl from '../services/getDataFromUrl';

const Thanks = ( props ) => {
    const dispatch = useDispatch()
    let [ getPrice, setGetPrice ] = useState(0);
    let callNumber      = useSelector(state => state.callNumber);
    let callEmail      = useSelector(state => state.callEmail);
    let isShop      = useSelector(state => state.isShop);
    let urlFormFinish       = useSelector(state => state.urlFormFinish)
    let urlFormFinishExternal       = useSelector(state => state.urlFormFinishExternal)
    let [ load, setLoad ] = useState(false);
    let email = useSelector(state => state.email)
    let [ counter, setCounter ] = useState(15);

    //data
    let identificator       = useSelector(state => state.identificator)
    let products            = useSelector(state => state.products)
    let repurchase          = useSelector(state => state.repurchase)
    let leasingTime         = useSelector(state => state.leasingTime)
    let initialCharge       = useSelector(state => state.initialCharge)
    let productPrice        = useSelector(state => state.productPrice)
    let productPriceEnd     = useSelector(state => state.productPriceEnd)
    let activeContract      = useSelector(state => state.selectedLease)
    let tax                 = useSelector(state => state.tax)
    let selectedLease       = useSelector(state => state.selectedLease)
    let modernLease         = useSelector(state => state.modernLease)
    let finalRate           = useSelector(state => state.finalRate)
    let rateFrequency       = useSelector(state => state.rateFrequency)
    let providerPostal      = useSelector(state => state.providerPostal)
    let chargePrice         = useSelector(state => state.chargePrice)
    let minMonth            = useSelector(state => state.minMonth)
    let maxMonth            = useSelector(state => state.maxMonth)
    let providerName        = useSelector(state => state.providerName)
    let providerNip         = useSelector(state => state.providerNip)

    // 
    let nip                     = useSelector(state => state.nip)
    let companyName             = useSelector(state => state.companyName)
    let companyAddress          = useSelector(state => state.companyAddress)
    let postalCustomer          = useSelector(state => state.postalCustomer)
    let city                    = useSelector(state => state.city)
    let companyStart            = useSelector(state => state.companyStart)
    let registryType            = useSelector(state => state.registryType)
    let idNumber                = useSelector(state => state.idNumber)
    let phone                   = useSelector(state => state.phone)
    let lawForm                 = useSelector(state => state.lawForm)
    let profession              = useSelector(state => state.profession)
    let employeesNumber         = useSelector(state => state.employeesNumber)
    let website                 = useSelector(state => state.website)
    let additionalCompanyAddress          = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer          = useSelector(state => state.additionalPostalCustomer)
    let additionalCity                    = useSelector(state => state.additionalCity)

    //
    let authorizedPersons        = useSelector(state => state.authorizedPersons)

    //
    let taxArrears                  = useSelector(state => state.taxArrears)
    let taxArrearsPrice             = useSelector(state => state.taxArrearsPrice)
    let ZUSarrears                  = useSelector(state => state.ZUSarrears)
    let ZUSarrearsPrice             = useSelector(state => state.ZUSarrearsPrice)
    let enforcementProceedings      = useSelector(state => state.enforcementProceedings)
    let enforcementProceedingsPrice = useSelector(state => state.enforcementProceedingsPrice)
    let prevYearRevenues            = useSelector(state => state.prevYearRevenues)
    let revenueOld                  = useSelector(state => state.revenueOld)
    let revenueScoreOld             = useSelector(state => state.revenueScoreOld)
    let revenueProfitOld            = useSelector(state => state.revenueProfitOld)
    let revenue                     = useSelector(state => state.revenue)
    let revenueFrom                 = useSelector(state => state.revenueFrom)
    let revenueTo                   = useSelector(state => state.revenueTo)
    let revenueScore                = useSelector(state => state.revenueScore)
    let revenueProfit               = useSelector(state => state.revenueProfit)
    //
    let realEstatesItems                 = useSelector(state => state.realEstatesItems)
    let fundsItems                       = useSelector(state => state.fundsItems)
    //
    let otherCreditsItems                = useSelector(state => state.otherCreditsItems)
    //
    let authCheckOne        = useSelector(state => state.authCheckOne)
    let authCheckTwo        = useSelector(state => state.authCheckTwo)
    let authName            = useSelector(state => state.authName)
    let authSurname         = useSelector(state => state.authSurname)
    let authAddress         = useSelector(state => state.authAddress)
    let authPesel           = useSelector(state => state.authPesel)
    let authId              = useSelector(state => state.authId)
    let authCheckThree      = useSelector(state => state.authCheckThree)
    let authCheckFour       = useSelector(state => state.authCheckFour)
    let authCheckFive       = useSelector(state => state.authCheckFive)
    let authCheckSix        = useSelector(state => state.authCheckSix)
    let comments            = useSelector(state => state.comments)
    let postman             = useSelector(state => state.postman)
    let emailbill           = useSelector(state => state.emailbill)
    


    useEffect(() => {
      if ( !load ) {
        dispatch({ type: 'END_PAGE_CHANGE', value: true })
        // runDataLayer();
        // runCounter();
        getUrlParams();
        if(typeof window !== "undefined") {
            window.dataLayer.push({'event':'pageview'});
        }
      }
      
    }, [load])

    let prev = () => {
        if ( urlFormFinishExternal ) { 
            window.location.href = urlFormFinish;
        } else {
            props.history.push(urlFormFinish);
        }
    }
    dispatch({ type: 'STEPS_CHANGE', value: 6 })

    const getUrlParams = async() => {
        let getEmail = getDataFromUrl('email');
        let getNumberCall = getDataFromUrl('callNumber');
        let getEmailCall = getDataFromUrl('callEmail');
        let getPriceValue = getDataFromUrl('price');

        await dispatch({ type: 'EMAIL_CHANGE', value: getEmail } )
        await dispatch( {type: 'CALL_NUMBER_CHANGE', value:  getNumberCall } )
        await dispatch( {type: 'CALL_EMAIL_CHANGE', value:  getEmailCall } ) 
        setGetPrice(getPriceValue);
    }

    const runCounter = () => {
        const run = setInterval(function() {
            if(counter == 1) {
                setCounter(--counter)
                clearInterval(run);
                prev();
            }else{
                setCounter(--counter)
            }
        }, 1000);
    }

    let searchInLawForms = (val) => {
        let key = ''
        lawForms.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }
    let searchInProffesions = (val) => {
        let key = ''
        proffessions.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }

    let reconvertPrice = (val) => {
        if(val && val.length > 0) {
            let valuePrice = val.replace(/ /g,'');
            valuePrice = valuePrice.replace('zł', '');
            valuePrice = valuePrice.replace(',','.');
    
            return(valuePrice);
        }
    }

    const runDataLayer = () => {
        let data = [
            {
                "identificator": identificator,
                "isShop": isShop,
                "products": products,
                "type": selectedLease,
                "value": productPrice,
                "productPriceEnd": reconvertPrice(productPriceEnd),
                "price": reconvertPrice(chargePrice),
                "initial": reconvertPrice(initialCharge),
                "tax": reconvertPrice(tax),
                "repurchase": repurchase,
                "finalRate": finalRate,
                "rateFrequency": rateFrequency,
                "minMonths": minMonth,
                "maxMonths": maxMonth,
                "months": leasingTime,
                "selectedLeasing": activeContract,
                "enableModernLease": modernLease,
                "providerName": providerName,
                "providerPostal": providerPostal,
                "providerNip": providerNip,
                'callNumber': callNumber
            },
            {
                "nip": nip,
                "company": companyName,
                "address": companyAddress,
                "city": city,
                "email": email,
                "postcode": postalCustomer,
                "companyStart": companyStart,
                "registryType": registryType,
                "krs": idNumber,
                "phone": phone,
                "company_type": searchInLawForms(lawForm),
                "company_sector": searchInProffesions(profession),
                "employeesNumber": employeesNumber,
                "www": website,
                "additionalCompanyAddress": additionalCompanyAddress,
                "additionalPostalCustomer": additionalPostalCustomer,
                "additionalCity": additionalCity,
            },
            // {
            //     "representatives": authorizedPersons
            // },
            {
                "taxArrears": taxArrears,
                "taxArrearsPrice": reconvertPrice(taxArrearsPrice),
                "ZUSarrears": ZUSarrears,
                "ZUSarrearsPrice": reconvertPrice(ZUSarrearsPrice),
                "enforcementProceedings": enforcementProceedings,
                "enforcementProceedingsPrice": reconvertPrice(enforcementProceedingsPrice),
                "prevYearRevenues": prevYearRevenues,
                "revenue": reconvertPrice(revenue),
                "revenueOld": reconvertPrice(revenueOld),
                "revenueScoreOld": revenueScoreOld,
                "revenueProfitOld": reconvertPrice(revenueProfitOld),
                "revenueFrom": revenueFrom,
                "revenueTo": revenueTo,
                "revenueScore": revenueScore,
                "revenueProfit": reconvertPrice(revenueProfit),
            },
            {
                "realEstatesItems": realEstatesItems,
                "fundsItems": fundsItems,
            },
            {
                "otherCreditsItems": otherCreditsItems
            },
            {
                "authCheckOne": authCheckOne,
                "authCheckTwo": authCheckTwo,
                "authName": authName,
                "authSurname": authSurname,
                "authAddress": authAddress,
                "authPesel": authPesel,
                "authId": authId,
                "authCheckThree": authCheckThree,
                "authCheckFour": authCheckFour,
                "authCheckFive": authCheckFive,
                "authCheckSix": authCheckSix,
                "comments": comments,
                "postman": postman,
                "emailInvoice": emailbill,
            },
        ];
        // const tagManagerArgs = {
        //     dataLayer: {
        //         data: data,
        //         page: 'dziekujemy'
        //     },
        //     dataLayerName: "FinishForm"
        // }
        window.dataLayer.push({
            dataLayerName: "FinishForm",
            page: 'dziekujemy',
            data: data
        })
        // TagManager.dataLayer(tagManagerArgs)
    }

    return (
        <section className="form">
            <div className="container">
                <div className="thanks">
                    <div id="countdown">
                        {/* <div id="countdown-number">{counter}</div>
                        {counter > 0 &&
                            <svg>
                                <circle r="60" cx="58" cy="58"></circle>
                            </svg>
                        } */}
                    </div>
                    {getPrice < 50000 &&
                    <>
                        <Heading title={`Dziękujemy za złożenie wniosku leasingowego do GRENKE – potwierdzenie zostało wysłane na adres ${email}`} />
                        <Text text={`Wkrótce przekażemy decyzję dotyczącą możliwości udzielenia leasingu.`} />
                        <Text text={`Jesteśmy dostępni od poniedziałku do piątku, w godzinach oo 8.00 do 16.00`} />
                    </>
                    }
                    {getPrice >= 50000 && getPrice <= 100000 &&
                    <>
                        <Heading title={`Dziękujemy za złożenie wniosku leasingowego do GRENKE `} />
                        <Text text={`Odbierz e-mail wysłany na adres <strong>${ email }</strong> i jak najszybciej <strong>ODEŚLIJ DO NAS SKAN PODPISANEGO WNIOSKU</strong>, który został pobrany na Twój komputer.`} />
                        <Text text={`Wkrótce przekażemy decyzję dotyczącą możliwości udzielenia leasingu.`} />
                        <Text text={`Jesteśmy dostępni od poniedziałku do piątku, w godzinach oo 8.00 do 16.00`} />
                    </>
                    }
                    {getPrice > 100000 &&
                    <>
                        <Heading title={`Dziękujemy za złożenie wniosku leasingowego do GRENKE `} />
                        <Text text={`Odbierz e-mail wysłany na adres <strong>${ email }</strong> i jak najszybciej <strong>ODEŚLIJ DO NAS</strong>`} />
                        <Text text={`
                            <ul>
                                <li><strong>SKAN PODPISANEGO WNIOSKU</strong>, który został pobrany na Twój komputer</li>
                                <li><strong>DOKUMENTY FINANSOWE</strong> za rok bieżący oraz dwa poprzednia lata</li>
                            </ul>
                        `} />
                        <Text text={`Wkrótce przekażemy decyzję dotyczącą możliwości udzielenia leasingu.`} />
                        <Text text={`Jesteśmy dostępni od poniedziałku do piątku, w godzinach oo 8.00 do 16.00`} />
                    </>
                    }
                    {/* <Heading title="Dziękujemy za złożenie wniosku leasingowego do GRENKE." />
                    <Text text={`Odbierz e-mail wysłany na adres <a href="mailto:${ email }"><strong>${ email }</strong></a> i <strong>WYKONAJ PRZELEW WERYFIKACYJNY</strong> korzystając z linku załączonego do wiadomości.`} />
                    <Text text="Rozpatrzymy Twój wniosek i wkrótce przekażemy decyzję dotyczącą możliwości udzielenia leasingu." />
                    <Text text="Jesteśmy dostępni od poniedziałku do piątku, w godzinach od 8.00 do 16.00." /> */}

                    <div className="boxes thanks-call">
                        <div className="col">
                            <div className="call-box">
                                <div className="icon">
                                    <img src={ phoneIco } alt="Zadzwoń"/>
                                </div>
                                <div className="text">
                                    <p>W przypadku pytań <br/> zadzwoń</p>
                                    {callNumber &&
                                        // <a href={"tel:" + (isShop ? '61 872 37 00' : callNumber.replace('/', ''))}>{ (isShop ? '61 / 872 37 00' : callNumber) }</a>
                                        <a href={"tel:" + (isShop ? '61 872 37 16' : callNumber.replace('/', ''))}>{ (isShop ? '61 872 37 16' : callNumber) }</a>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col big">
                            <div className="call-box">
                                <div className="icon">
                                    <img className="envelope" src={ envelopeIco } alt="Zadzwoń"/>
                                </div>
                                <div className="text">
                                    <p>W przypadku pytań <br/> napisz e-mail</p>
                                    <a href={"mailto:" + (isShop ? 'service@grenke.pl' : callEmail) }>{ (isShop ? 'service@grenke.pl' : callEmail)}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="buttons-row">
                    <div className="col">
                        <Button title="Powrót" class="white reverse" arrowPrevBlue={ true } setFunction={ () => prev() } />
                    </div>
                    <div className="col"></div>
                </div>
            </div>
        </section>
    )
    
}

export default Thanks;